(function () {
    'use strict';

    function setupMenu() {
        const menuToggle = document.getElementById('menu-toggle');
        const closeMenu = document.getElementById('close-menu');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileOverlay = document.getElementById('mobile-menu-overlay');
        const body = document.body;

        if (!menuToggle || !closeMenu || !mobileMenu || !mobileOverlay) return;

        function toggleMenu(open) {
            if (open) {
                mobileMenu.classList.remove('translate-x-full');
                mobileOverlay.classList.remove('hidden');
                body.classList.add('overflow-hidden');
                menuToggle.setAttribute('aria-expanded', 'true');
            } else {
                mobileMenu.classList.add('translate-x-full');
                mobileOverlay.classList.add('hidden');
                body.classList.remove('overflow-hidden');
                menuToggle.setAttribute('aria-expanded', 'false');
            }
        }

        menuToggle.addEventListener('click', () => toggleMenu(true));

        closeMenu.addEventListener('click', () => toggleMenu(false));
        mobileOverlay.addEventListener('click', () => toggleMenu(false));

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                toggleMenu(false);
            }
        });
    }

    function sortDropDown() {
        const sortDropdown = document.getElementById("sort");

        if (!sortDropdown) return;

        function getSortParam() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get("sort");
        }

        function setSelectedOption() {
            const currentSort = getSortParam();
            if (!currentSort) return;

            Array.from(sortDropdown.options).forEach(option => {
                if (option.value === currentSort) {
                    option.selected = true;
                }
            });
        }

        sortDropdown.addEventListener("change", function () {
            const selectedOption = sortDropdown.options[sortDropdown.selectedIndex];
            const url = selectedOption.getAttribute("data-url");

            if (url) {
                window.location.href = url;
            }
        });

        setSelectedOption();
    }

    function resizeImages() {
        document.querySelectorAll(".image-container img").forEach(img => {
            img.style.objectFit = "cover";
            img.style.width = "100%";
            img.style.height = "100%";
        });
    }

    function setupFilters() {

            const mobileFiltersBtn = document.getElementById("mobile-filters-btn");
            const mobileFiltersPanel = document.getElementById("mobile-filters-panel");
            const closeFiltersBtn = document.getElementById("close-filters-btn");


            if (mobileFiltersBtn && mobileFiltersPanel && closeFiltersBtn) {
                mobileFiltersBtn.addEventListener("click", () => {
                    mobileFiltersPanel.classList.remove("translate-x-full");
                });

                closeFiltersBtn.addEventListener("click", () => {
                    mobileFiltersPanel.classList.add("translate-x-full");
                });
            }



            const openBtn = document.getElementById("openTypeFilters");
            const modal = document.getElementById("typeFilterModal");

            if (openBtn && closeFiltersBtn && modal) {
                openBtn.addEventListener("click", function () {
                    modal.classList.remove("hidden");
                    document.body.classList.add("overflow-hidden");
                });

                closeFiltersBtn.addEventListener("click", function () {
                    modal.classList.add("hidden");
                    document.body.classList.remove("overflow-hidden");
                });
            }




            const filtersBtn = document.getElementById("mobile-filters-btn");
            const popup = document.getElementById("mobile-filters-popup");
            const filtersForm = document.getElementById("mobile-filters-form");
            const resetBtn = document.getElementById("reset-btn");

            if (!filtersBtn || !closeFiltersBtn || !popup || !filtersForm || !resetBtn) {
                console.error("Some filter elements are missing in the DOM.");
                return;
            }

            window.selectedParams = window.selectedParams || {};

            filtersBtn.addEventListener("click", function () {
                popup.classList.remove("hidden");
                popup.classList.add("flex");
                document.body.style.overflow = "hidden";
                loadFilters();
            });

        closeFiltersBtn.addEventListener("click", function () {
                popup.classList.add("hidden");
                popup.classList.remove("flex");
                document.body.style.overflow = "auto";
            });

            resetBtn.addEventListener("click", function () {
                console.log("🔄 Resetting filters...");
                window.selectedParams = {};
                document.querySelectorAll("#mobile-filters-form select").forEach(select => {
                    select.value = "";
                });
                loadFilters();
            });


            const searchForm = document.getElementById("mobile-filters-form");
            const spinner = document.getElementById("search-spinner");

            function loadFilters() {
                spinner.classList.remove("hidden");
                searchForm.classList.add("pointer-events-none", "opacity-50");

                const queryParams = new URLSearchParams(selectedParams).toString();
                console.log("Loading filters with params:", queryParams);

                fetch(`/mobile-filters?${queryParams}`)
                    .then(response => response.json())
                    .then(data => {
                        populateFilters(data);
                        populatePriceDropdowns(data.pricesFrom, data.pricesTo);
                        populateYearDropdowns(data.yearsFrom, data.yearsTo);
                    })
                    .catch(error => console.error("Error loading filters:", error))
                    .finally(() => {
                        spinner.classList.add("hidden");
                        searchForm.classList.remove("pointer-events-none", "opacity-50");
                    });

            }

            function populateFilters(data) {
                populateFilter("filter-make", "idMake", "Make", data.makes);
                if (window.selectedParams.idMake && data.models.length > 0) {
                    populateFilter("filter-model", "idModel", "Model", data.models);
                } else {
                    document.getElementById("filter-model").innerHTML = "";
                }
                populateFilter("filter-type", "idType", "Type", data.types);
                populateFilter("filter-condition", "used", "Condition", data.conditions);
                populateFilter("filter-pullType", "idPullType", "Pull Type", data.pullTypes);
                populateFilter("filter-slide-outs", "slideOut", "Slide outs", data.slideOuts);
                populateFilter("filter-sleeps", "sleepsNum", "Sleeps number", data.sleepNumbers);
                populateFilter("filter-living-quarters", "lq", "Living quarters", data.livingQuarters);
                populateFilter("filter-horse-numbers", "horseNum", "Horse number", data.horseNumbers);
                populateFilter("filter-fueltypes", "idFuelType", "Fuel types", data.fuelTypes);


                const searchBtn = document.getElementById("search-btn");
                if (searchBtn) {
                    searchBtn.setAttribute("data-url", data.searchUrl || "#");
                }
            }

        function populateFilter(containerId, paramKey, label, options) {
            const container = document.getElementById(containerId);
            if (!container) return;

            let selectedValue = window.selectedParams[paramKey] || "";

            let selectHTML = `<select class="dropdown-style mt-1" data-param="${paramKey}" ${options.length === 0 ? "disabled" : ""}>`;

            if (!options || options.length === 0) {
                console.warn(`No options available for: ${paramKey}`);
                selectHTML += `<option value="" selected>${label} (No options available)</option>`;
            } else {
                selectHTML += `<option value="" ${selectedValue === "" ? "selected" : ""}>${label}</option>`;
                options.forEach(opt => {
                    let key = paramKey === "used" ? "used" : Object.keys(opt).find(k => k.startsWith("id")) || paramKey;
                    const optionValue = opt[key] !== undefined ? opt[key] : "";
                    const isSelected = selectedValue == optionValue && selectedValue !== "" ? 'selected' : '';
                    const displayText = `${opt.name} (${opt.displayCount || 0})`;

                    selectHTML += `<option value="${optionValue}" ${isSelected}>${displayText}</option>`;
                });
            }

            selectHTML += `</select>`;
            container.innerHTML = selectHTML;

            const selectElement = container.querySelector("select");
            if (!selectElement) {
                console.error(`Dropdown not found inside: ${containerId}`);
                return;
            }

            if (options.length > 0) {
                selectElement.addEventListener("change", function () {
                    window.selectedParams[paramKey] = this.value || "";
                    loadFilters();
                });
            }
        }



        document.getElementById("search-btn").addEventListener("click", function (e) {
                e.preventDefault();
                window.location.href = this.getAttribute("data-url");
            });

        function populatePriceDropdowns(pricesFrom, pricesTo) {
            const priceFromDropdown = document.getElementById("price-from");
            const priceToDropdown = document.getElementById("price-to");

            if (!priceFromDropdown || !priceToDropdown) return;

            let selectedPriceFrom = (window.selectedParams.priceFrom !== undefined && window.selectedParams.priceFrom !== null)
                ? window.selectedParams.priceFrom
                : "-1";
            let selectedPriceTo = (window.selectedParams.priceTo !== undefined && window.selectedParams.priceTo !== null)
                ? window.selectedParams.priceTo
                : "10000000";

            priceFromDropdown.innerHTML =
                pricesFrom.map(opt => `
        <option value="${opt.value}" ${selectedPriceFrom == opt.value ? "selected" : ""}>
            ${opt.displayValue}
        </option>
    `).join("");

            priceToDropdown.innerHTML =
                pricesTo.map(opt => `
        <option value="${opt.value}" ${selectedPriceTo == opt.value ? "selected" : ""}>
            ${opt.displayValue}
        </option>
    `).join("");

            function validatePriceSelection() {
                let fromValue = parseInt(priceFromDropdown.value) || -1;
                let toValue = parseInt(priceToDropdown.value) || 10000000;

                let updated = false;

                if (fromValue > 0 && (toValue === 10000000 || fromValue > toValue)) {
                    priceToDropdown.value = "10000000";
                    updated = true;
                }

                if (
                    window.selectedParams.priceFrom !== priceFromDropdown.value ||
                    window.selectedParams.priceTo !== priceToDropdown.value ||
                    updated
                ) {
                    window.selectedParams.priceFrom = priceFromDropdown.value;
                    window.selectedParams.priceTo = priceToDropdown.value;

                    loadFilters();
                }
            }
            priceFromDropdown.addEventListener("change", validatePriceSelection);
            priceToDropdown.addEventListener("change", validatePriceSelection);
        }




        function populateYearDropdowns(yearsFrom, yearsTo) {
            const yearFromDropdown = document.getElementById("year-from");
            const yearToDropdown = document.getElementById("year-to");

            if (!yearFromDropdown || !yearToDropdown) return;

            let selectedYearFrom = (window.selectedParams.yearFrom !== undefined && window.selectedParams.yearFrom !== null)
                ? window.selectedParams.yearFrom
                : "-1";

            let selectedYearTo = (window.selectedParams.yearTo !== undefined && window.selectedParams.yearTo !== null)
                ? window.selectedParams.yearTo
                : "-1";

            yearFromDropdown.innerHTML =
                yearsFrom.map(opt => `
            <option value="${opt.value}" ${selectedYearFrom == opt.value ? "selected" : ""}>
                ${opt.displayValue}
            </option>
        `).join("");

            yearToDropdown.innerHTML =
                yearsTo.map(opt => `
            <option value="${opt.value}" ${selectedYearTo == opt.value ? "selected" : ""}>
                ${opt.displayValue}
            </option>
        `).join("");

            function validateYearSelection() {
                const fromValue = parseInt(yearFromDropdown.value, 10) || -1;
                const toValue = parseInt(yearToDropdown.value, 10) || Infinity;

                let updated = false;

                if (fromValue > -1 && fromValue > toValue) {
                    yearToDropdown.value = "-1";
                    updated = true;
                }

                if (
                    window.selectedParams.yearFrom !== yearFromDropdown.value ||
                    window.selectedParams.yearTo !== yearToDropdown.value ||
                    updated
                ) {
                    window.selectedParams.yearFrom = yearFromDropdown.value;
                    window.selectedParams.yearTo = yearToDropdown.value;

                    loadFilters();
                }
            }

            yearFromDropdown.addEventListener("change", validateYearSelection);
            yearToDropdown.addEventListener("change", validateYearSelection);
        }


        const advancedSearchBtn = document.getElementById("advanced-search-btn");
            const advancedFilters = document.getElementById("advanced-filters");

            if (advancedSearchBtn && advancedFilters) {
                advancedSearchBtn.addEventListener("click", function (event) {
                    event.preventDefault();
                    const isHidden = advancedFilters.classList.contains("hidden");

                    if (isHidden) {
                        advancedFilters.classList.remove("hidden");
                        advancedSearchBtn.innerHTML = "Advanced Search ▲";
                    } else {
                        advancedFilters.classList.add("hidden");
                        advancedSearchBtn.innerHTML = "Advanced Search ▼";
                    }
                });
            }
    }

    function setupJsFilters() {
        const params = new URLSearchParams(window.selectedParams).toString();

        fetch(`/js-filters?${params}`)
            .then(response => response.json())
            .then(data => {
                if (window.selectedParams.priceFrom === -1 && window.selectedParams.priceTo === 10000000) {
                    renderFilters(data.priceFilters, "Price", "price-filters-container");
                }
                if (window.selectedParams.yearFrom === -1 && window.selectedParams.yearTo === 10000) {
                    renderFilters(data.yearFilters, "Year", "year-filters-container");
                }
                if (window.selectedParams.lengthFrom === -1 && window.selectedParams.lengthTo === 5000) {
                    renderFilters(data.lengthFilters, "Length", "length-filters-container");
                }
                if (window.selectedParams.lq === null) {
                    renderFilters(data.lqFilters, "Living Quarters", "lq-filters-container");
                }
                if (window.selectedParams.horseNum === null) {
                    renderFilters(data.horseNumFilters, "Horse Number", "horse-num-filters-container");
                }
                if (window.selectedParams.idFuelType === null) {
                    renderFilters(data.fuelTypeFilters, "Fuel Type", "fuel-type-filters-container");
                }
                if (window.selectedParams.sleepsNum === null) {
                    renderFilters(data.sleepsNumFilters, "Sleeps", "sleeps-num-filters-container");
                }
                if (window.selectedParams.slideOuts === null) {
                    renderFilters(data.slideOutsFilters, "Slide Outs", "slide-outs-filters-container");
                }
            })
            .catch(error => console.error("Error loading filters:", error));

        function renderFilters(filters, title, containerId) {
            const container = document.getElementById(containerId);
            if (!container || !filters || filters.length === 0) return;

            let filterHTML = `<div class="mt-6">
            <h3 class="text-sm font-semibold text-gray-700">${title}</h3>
            <ul class="space-y-1 mt-1 text-sm">`;

            filters.slice(0, 10).forEach(filter => {
                filterHTML += `
                <li>
                    <a href="${filter.url}" class="block text-gray-700 hover:text-blue-500" rel="nofollow">
                        ${filter.title} (${filter.alt || 0})
                    </a>
                </li>`;
            });

            filterHTML += `</ul>`;
            filterHTML += `</div>`;
            container.innerHTML = filterHTML;
        }
    }

    const FAVORITES_KEY = 'favoriteTrailers';
    const MAX_FAVORITES = 5;

    function getFavorites() {
        return JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    }

    function saveFavorites(favorites) {
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    }

    function toggleFavorite(trailerId) {
        const idStr = String(trailerId); // Always treat IDs as strings
        let favorites = getFavorites();

        const index = favorites.indexOf(idStr);
        if (index !== -1) {
            // Remove from favorites
            favorites.splice(index, 1);
        } else {
            // Add to beginning, keep max 5
            favorites.unshift(idStr);
            if (favorites.length > MAX_FAVORITES) {
                favorites = favorites.slice(0, MAX_FAVORITES);
            }
        }

        saveFavorites(favorites);
        updateFavoriteIcons();
        renderFavoriteList();
    }

    function updateFavoriteIcons() {
        const favorites = getFavorites();
        document.querySelectorAll('.favorite-toggle').forEach(button => {
            const trailerId = button.getAttribute('data-trailer-id'); // Keep as string
            const icon = button.querySelector('.favorite-icon');
            if (!icon) return;

            if (favorites.includes(trailerId)) {
                icon.classList.add('text-red-500');
                icon.classList.remove('text-gray-400');
            } else {
                icon.classList.add('text-gray-400');
                icon.classList.remove('text-red-500');
            }
        });
    }

    function bindFavoriteButtons() {
        document.querySelectorAll('.favorite-toggle').forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const trailerId = button.getAttribute('data-trailer-id'); // Always string
                toggleFavorite(trailerId);
            });
        });
    }

    function renderFavoriteList() {
        const favorites = getFavorites();
        if (favorites.length === 0) {
            updateListDOM('<p class="text-gray-500">No favorites yet.</p>');
            return;
        }

        fetch(`/favoritetrailers?ids=${favorites.join(',')}`)
            .then(res => res.json())
            .then(trailers => {
                const html = trailers.map(t => `
                <a href="${t.detailUrl.url}" class="block hover:bg-gray-50 p-2 rounded">
                    <div class="flex items-center space-x-3">
                        <img src="${t.defaultImageUrl}" alt="${t.adTitle}" class="w-12 h-10 object-cover rounded">
                        <div>
                            <p class="text-sm font-medium text-gray-900">${t.adTitle}</p>
                            <p class="text-xs text-gray-500">${t.displayState ? t.displayState + ', ' : ''}${t.displayCity}</p>
                        </div>
                    </div>
                </a>
            `).join('');
                updateListDOM(html);
            });
    }

    function updateListDOM(html) {
        const mobileList = document.getElementById('favorites-list-mobile');
        const desktopList = document.getElementById('favorites-list-desktop');
        if (mobileList) mobileList.innerHTML = html;
        if (desktopList) desktopList.innerHTML = html;
    }

    //
    // ✅ NEW FUNCTION: setupFavoritesDropdownToggle
    //
    function setupFavoritesDropdownToggle() {
        const toggleBtn = document.getElementById('favorites-toggle');
        const dropdown = document.getElementById('favorites-dropdown');
        const wrapper = document.getElementById('favorites-wrapper');

        if (!toggleBtn || !dropdown || !wrapper) return;

        toggleBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            dropdown.classList.toggle('hidden');
        });

        document.addEventListener('click', (e) => {
            if (!wrapper.contains(e.target)) {
                dropdown.classList.add('hidden');
            }
        });
    }

    function setupMobileFavoritesToggle() {
        const toggleBtn = document.getElementById('mobile-favorites-toggle');
        const listContainer = document.getElementById('favorites-list-mobile');
        const chevron = document.getElementById('mobile-favorites-chevron');

        if (!toggleBtn || !listContainer) return;

        toggleBtn.addEventListener('click', () => {
            const isHidden = listContainer.classList.contains('hidden');

            if (isHidden) {
                listContainer.classList.remove('hidden');
                if (chevron) chevron.classList.add('rotate-180');
            } else {
                listContainer.classList.add('hidden');
                if (chevron) chevron.classList.remove('rotate-180');
            }
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        setupMenu();
        sortDropDown();
        resizeImages();
        setupFilters();
        setupJsFilters();
        bindFavoriteButtons();
        updateFavoriteIcons();
        renderFavoriteList();
        setupFavoritesDropdownToggle();
        setupMobileFavoritesToggle();
    });

}());
